var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20655 0.9C8.14861 -0.3 6.44836 -0.3 5.39043 0.9L5 1.34286L4.60957 0.9C3.55164 -0.3 1.85139 -0.3 0.793451 0.9C-0.264484 2.1 -0.264484 4.02857 0.793451 5.22857L5 10L9.20655 5.22857C10.2645 4.02857 10.2645 2.08571 9.20655 0.9Z",
    fill: "url(#paint0_linear_7280_25097)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7280_25097",
    x1: 1.94244,
    y1: -0.413286,
    x2: 8.827,
    y2: 5.65623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5B42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardHeart);
export default __webpack_public_path__ + "static/media/cardHeart.4245a6cacb424d233025f4cf17c7249b.svg";
export { ForwardRef as ReactComponent };